<div class="mt-1" (click)="hideDropdowns();">
    <div class="row" style="border-bottom: 1px solid #d0d0ce;">
      <div class="col-md-3">
        <h2>Outward Requests</h2>
      </div>    
      <div class="col-md-11 col-xl-9 d-flex justify-content-end">
        <div class="row d-flex justify-content-end">
          <div class="col-md-4 col-xl-8  d-flex justify-content-center headermargin" style="margin-right: 100px;">
            <div class="form-group typeahead-wrap mt-0" style="width:100%;margin-right: 10px;">
              <input type="text" class="form-control dpinputwidth" [ngModel]="dateInputData.StartDate"
                     (ngModelChange)="dateInputData.StartDate=$event" autocomplete="off" name="fromDate" id="fromDate"
                     [minDate]="dateInputData.FromMinDate" [maxDate]="dateInputData.maxDate"
                     [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" placeholder="MM/DD/YYYY"
                     placement="bottom left" #fromdate #fromDate="bsDatepicker" bsDatepicker>
              <i class="icon-ic_calendar show-cursor" (click)="fromDate.toggle()">
                 </i>
            </div>
            <div class="mt-1">-</div>
            <div class="form-group typeahead-wrap mt-0" style="width:100%;margin-left:10px;">
              <input type="text" class="form-control dpinputwidth" [ngModel]="dateInputData.EndDate"
                      [disabled]="!dateInputData.EndDate" autocomplete="off" name="toDate" id="toDate"
                      autocomplete="off" 
                      placeholder="MM/DD/YYYY" placement="bottom left"  (ngModelChange)="dateInputData.EndDate=$event"
                      [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" #todate #toDate="bsDatepicker"
                      bsDatepicker>
              <i class="icon-ic_calendar show-cursor" (click)="toDate.toggle()">
                 </i>
            </div>
            <div class="form-group has-search">
              <span class="icon-ic_search form-control-search"></span>
              <input class="form-control frontIcon searchtext" #userame id="username" autocomplete="off" placeholder="Search by request name,ID or G.P.No">
            </div>
            <button (click)="SearchByUser(userame.value,dateInputData.StartDate,dateInputData.EndDate)"  class="button ml-3 mr-auto" type="button">
              Search
            </button>
            &nbsp;
            <button (click)="ResetFilters()" class="button" type="button" style="background-color: #53565A;color:#fff">
              Reset
            </button>
            <div class="separator"></div>
          </div>
        <!-- <div class="col-md-5 col-xl-4 d-flex justify-content-end">
            
          <button (click)="ResetFilters()" class="button" type="button" style="background-color: #53565A;color:#fff">
            Reset
          </button>
             <button  class="button" type="button" style="background-color: #53565A;color:#fff">
              Export
            </button>
            COMMENT  <button (click)="addOffice()" class="button blue" type="button">
              Add Office
            </button>   COMMENT
            <button class="button blue"  routerLink="/AddOutward" type="button" style="background-color: #007CB0;">
                New Registration
              </button> 
          </div> -->
      </div>
    </div>
  </div>
  
  </div>
  